export const warmcool = {
  name: 'Warm & Cool',
  color: [0.807843137254902, 0.35294117647058826, 0.3411764705882353, 1],
  bg: [0.26666666666666666, 0.2980392156862745, 0.3607843137254902, 1],
  grid1: [0.47058823529411764, 0.6470588235294118, 0.6392156862745098, 1],
  grid2: [0.8823529411764706, 0.6941176470588235, 0.41568627450980394, 1],
}
